import {MetadataModalProps} from './types'
import MetadataPromiseModalView from './MetadataPromiseModalView'
import React from 'react'

const MetadataPromiseModal = (props: MetadataModalProps): React.ReactElement => <MetadataPromiseModalView {...props} />

export default MetadataPromiseModal
